import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockStartOnboarding, mockFetchOnboardingStatus,
  mockUpdateOnboardingStep, mockActivateTenant,
} from "../mock/mockHandlers";

const onboardingPath = (tenantId) => `/tenants/${tenantId}/onboarding`;

export const startOnboarding = (tenantId) =>
  USE_MOCK ? mockStartOnboarding(tenantId) : request(`${onboardingPath(tenantId)}/start`, { method: "POST" });
export const fetchOnboardingStatus = (tenantId) =>
  USE_MOCK ? mockFetchOnboardingStatus(tenantId) : request(`${onboardingPath(tenantId)}/status`);
export const updateOnboardingStep = (tenantId, stepKey, payload) =>
  USE_MOCK ? mockUpdateOnboardingStep(tenantId, stepKey, payload) : request(`${onboardingPath(tenantId)}/steps/${stepKey}`, { method: "PUT", data: payload });
export const activateTenant = (tenantId) =>
  USE_MOCK ? mockActivateTenant(tenantId) : request(`${onboardingPath(tenantId)}/activate`, { method: "POST" });
